export type Provider = 'openai' | 'anthropic' | 'google'

export type OpenaiReasoningEffort = 'none' | 'low' | 'medium' | 'high'

export const DEFAULT_OPENAI_REASONING_EFFORT: OpenaiReasoningEffort = 'medium'

export interface ParsedModelId {
  provider: Provider
  model: string
}

/**
 * Parses `provider:model`. Returns null if the string is missing or malformed.
 */
export function parseModelId(modelId: string): ParsedModelId | null {
  const raw = String(modelId || '').trim()
  const [providerRaw, ...rest] = raw.split(':')
  const providerCandidate = (providerRaw || '').trim().toLowerCase() as Provider
  const modelCandidate = rest.join(':').trim()

  if (
    (providerCandidate === 'openai' || providerCandidate === 'anthropic' || providerCandidate === 'google') &&
    modelCandidate
  ) {
    return { provider: providerCandidate, model: modelCandidate }
  }

  return null
}

export function toModelId(provider?: string, model?: string): string {
  const safeProvider = String(provider || '').trim().toLowerCase()
  const safeModel = String(model || '').trim()
  if ((safeProvider === 'openai' || safeProvider === 'anthropic' || safeProvider === 'google') && safeModel) {
    return `${safeProvider}:${safeModel}`
  }
  return ''
}

/**
 * API payload value for `openai_reasoning_effort`.
 * OpenAI GPT-5.4 models always use `medium`; non-OpenAI providers store `none`.
 * The value is not user-configurable — it is locked to a sensible default.
 */
export function openaiReasoningEffortForApiPayload(
  llmProvider: Provider | string | undefined,
): OpenaiReasoningEffort {
  const p = String(llmProvider || '').trim().toLowerCase()
  if (p === 'openai') return DEFAULT_OPENAI_REASONING_EFFORT
  return 'none'
}
